angular
    .module("accordoConvenzionamento.components", [])
    .component("accordoConvenzionamento", {
        templateUrl: "ng/components/accordoConvenzionamento/accordoConvenzionamento.view.html",
        bindings: {},
        controller: AccordoConvenzionamentoController,
        controllerAs: "accordoConvenzionamentoCtrl"
    })

function AccordoConvenzionamentoController(
    $timeout,
    $simulationService,
    $configService,
    $location,
    $storageService

) {

    var self = this;

    self.$onInit = function () {

        self.mapInfo = "Nella sezione documentazione scaricabile, scaricare l'accordo di convenzionamento e tutti gli allegati. Nella checklist documenti, esegui l'upload dell'accordo convenzionamento firmato digitalmente";
        populateCheckListDownload();
        self.supportModel = {
            validateCheckListDown: false,
            validateCheckListUp: false,
            firmatario: {}
        }
    }



    self.nextValidity = function () {
        // aggiungere i controlli per abilitare il tasto avanti
        return self.supportModel.validateCheckListDown &&
            self.supportModel.validateCheckListUp;
    }


    self.next = function () {
        // aggiungere qui la funziona da chiamare alla pressione del tasto avanti
        self.enabledLoader = true;
        $simulationService
            .saveContrattoConvenzionamento(self.supportModel.firmatario, $configService.getUser().ndg, "CONV", self.listOfDocumentUpload[0].uploadedFiles[0].filename, null, null, null, true)
            .then(function (response) {
                if (response.success) {
                    $configService.init(response);
                    // let appConfig = $storageService.getAppConfig();
                    // appConfig.user.showCtrConv = false;
                    // $storageService.setAppConfig(appConfig)
                    location.reload();
                    $location.path('/');
                }
                self.enabledLoader = false;
            })
            .catch(function (error) {
                console.log(error);
                self.enabledLoader = false;
            })
    }


    var populateCheckListDownload = function () {
        self.restDownloadRunning = true;
        $simulationService.getCheckListContrattoConvenzionamento()
            .then(function (response) {
                console.log(response)
                self.listOfDocumentDownload = response.checklistDownload;
                self.listOfDocumentUpload = response.checklistUpload;
                self.restDownloadRunning = false;
            })
            .catch(function (error) {
                self.restDownloadRunning = false;
                console.log(error);
            })
    }

    self.validateChecklistDownload = function (validate) {
        self.supportModel.validateCheckListDown = validate;
    }

    self.validityUploadFile = function (validate, firmatario) {
        self.supportModel.validateCheckListUp = validate;
        self.supportModel.firmatario = firmatario
    }

}